import React from "react";
import { useCart } from "../../../hooks";

export default function CheckoutButton() {
  const { checkout } = useCart();
  return (
    <a
      className="hds-btn hds-btn__secondary rounded-full w-full font-a2"
      href={checkout.webUrl}
    >
      Checkout
    </a>
  );
}
